import { render, staticRenderFns } from "./industryDistribution.vue?vue&type=template&id=a3f03fda&scoped=true"
import script from "./industryDistribution.vue?vue&type=script&lang=js"
export * from "./industryDistribution.vue?vue&type=script&lang=js"
import style0 from "./industryDistribution.vue?vue&type=style&index=0&id=a3f03fda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f03fda",
  null
  
)

export default component.exports